<div [formGroup]="form">
    <div class="row">
        <div class="col-8"></div>
        <div class="col-4">
            @if (state.canEdit | async) {
                <button
                    class="btn btn-action btn-primary pull-right"
                    [disabled]="isOtherItemEdited"
                    bcClick
                    (clicked)="edit()"
                >
                    {{ "General.Edit" | translate }}
                </button>
            }
            @if (state.canEdit | async) {
                <button
                    class="btn btn-danger btn-action pull-right mr-1"
                    [disabled]="isOtherItemEdited"
                    bcClick
                    (clicked)="remove()"
                >
                    {{ "General.Remove" | translate }}
                </button>
            }
        </div>
    </div>
    <div class="row mt-2">
        <div class="col-8">
            <div class="card-text">
                <div class="row">
                    <div class="col-sm-3 bolded">
                        {{ "CampDetails.SessionName" | translate }}
                    </div>
                    <div class="col-sm-7">{{ form.controls.name.value }}</div>
                </div>
                <div class="row">
                    <div class="col-sm-3 bolded">
                        {{ "CampDetails.SessionDescription" | translate }}
                    </div>
                    <div class="col-sm-7">
                        {{ form.controls.description.value }}
                    </div>
                </div>
                <div class="row">
                    <div class="col-sm-3 bolded">
                        {{ "CampDetails.Club" | translate }}
                    </div>
                    <div class="col-sm-7">
                        {{ form.controls.clubName.value }}
                    </div>
                </div>
                <div class="row">
                    <div class="col-sm-3 bolded">
                        {{ "CampDetails.Capacity" | translate }}
                    </div>
                    <div class="col-sm-7">
                        @if (!isUnlimited) {
                            <span>{{ form.controls.capacity.value }}</span>
                        }
                        @if (isUnlimited) {
                            <span>{{
                                "CampDetails.Unlimited" | translate
                            }}</span>
                        }
                    </div>
                </div>
                <div class="row">
                    <div class="col-sm-3 bolded">
                        {{ "CampDetails.AgeRange" | translate }}
                    </div>
                    <div class="col-sm-7">
                        {{ form.controls.ageRangeFromInMonths.value | age }} -
                        {{ form.controls.ageRangeToInMonths.value | age }}
                        <i
                            class="fa fa-info-circle ml-2"
                            placement="right"
                            aria-hidden="true"
                            [tooltip]="ageRangeTooltip"
                        >
                        </i>
                    </div>
                    <ng-template #ageRangeTooltip
                        >{{ "CampDetails.AgeRangeExplanation" | translate }}
                    </ng-template>
                </div>
                <div class="row">
                    <div class="col-sm-3 bolded">
                        {{ "CampDetails.EffectiveAgeRange" | translate }}
                    </div>
                    <div class="col-sm-7">
                        {{
                            form.controls.ageRangeFromInMonthsEffective.value
                        }}
                        -
                        {{
                            form.controls.ageRangeToInMonthsEffective.value
                        }}
                        months
                    </div>
                </div>
                <div class="row">
                    <div class="col-sm-3 bolded">
                        {{ "CampDetails.TimeRangeVariant" | translate }}
                    </div>
                    <div class="col-sm-7">
                        {{
                            translateVariant(
                                form.controls.timeRangeVariant.value
                            )
                        }}
                    </div>
                </div>

                <div class="row">
                    <div class="col-sm-3 bolded">
                        {{ "CampDetails.TimeVariantPrice" | translate }}
                    </div>
                    <div class="col-sm-7">
                        {{ form.controls.basePrice.value | amount }}
                    </div>
                </div>
                <div class="row">
                    <div class="col-sm-3 bolded">
                        {{ "CampDetails.TimeVariantTimeRange" | translate }}
                    </div>
                    <div class="col-sm-7">
                        {{
                            form.controls.timeFromInMinutes.value | timeDisplay
                        }}
                        -
                        {{ form.controls.timeToInMinutes.value | timeDisplay }}
                    </div>
                </div>

                <div class="row">
                    <div class="col-sm-3 bolded">
                        {{
                            "CampDetails.AllowCustomVariantSelection"
                                | translate
                        }}
                    </div>
                    <div class="col-sm-7">
                        {{
                            form.controls.allowCustomVariantSelection.value
                                | yesno
                        }}
                    </div>
                </div>

                <div class="row">
                    <div class="col-sm-3 bolded">
                        {{
                            "CampDetails.AllowCampCreditPointsUsage" | translate
                        }}
                    </div>
                    <div class="col-sm-7">
                        {{
                            form.controls.allowCampCreditPointsUsage.value
                                | yesno
                        }}
                    </div>
                </div>

                <div class="row">
                    <div class="col-sm-3 bolded">
                        {{ "CampDetails.PhoneNumber" | translate }}
                    </div>
                    <div class="col-sm-7">
                        {{ form.controls.contactPhone.value }}
                    </div>
                </div>

                <div class="row">
                    <div class="col-sm-3 bolded">
                        {{ "CampDetails.Email" | translate }}
                    </div>
                    <div class="col-sm-7">
                        {{ form.controls.contactEmail.value }}
                    </div>
                </div>

                <div class="row">
                    <div class="col-sm-3 bolded">
                        {{ "CampDetails.WorkingHours" | translate }}
                    </div>
                    <div class="col-sm-7">
                        {{ form.controls.contactWorkingHours.value }}
                    </div>
                </div>
            </div>
        </div>
        <div class="col-4">
            <app-session-days
                [form]="sessionDaysForm"
                [readonly]="true"
            ></app-session-days>

            <app-session-days-shift [form]="form"></app-session-days-shift>
        </div>
    </div>
</div>
